import { Col, Form, Input, Modal, Row } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../theme/ThemeContext'
import { message } from 'antd' // 加个提示
import { SettingOutlined } from '@ant-design/icons'
import { SettingUseMethodModal } from './settingUseMethodModal'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { getPatientOptionsAsync } from '../../A-toothModule/toothHome/toothHomeSlice'
import { unwrapResult } from '@reduxjs/toolkit'

export const TFMethodModal = (props?: {
  value?: any,
  visible?: boolean,
  currentGroupIndex?: number,
  onChange: (values: any, index: any,) => void,
  onCancel?: () => void,
}): ReactElement => {
  const inputRef = React.useRef<any>(null)

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [dataList, setDataList] = useState<any[]>([])

  const [selectedValues, setSelectedValues] = useState<string[]>([])

  const [settingUseMethodVisible, setSettingUseMethodVisible] = useState<any>(false)

  const [selected, setSelected] = useState<any>()

  const [form] = Form.useForm()

  useEffect(() => {
    if (props?.visible) {
      getList()
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100);
      const values = (selectedValues?.length ? selectedValues : props?.value?.groupUsemethod?.split(',') || [])?.filter((v: any) => v != '')

      if (values?.length) {
        form.setFieldsValue({
          useMethod: values?.join('，') || values?.join(','),
        })
      }
    }
  }, [selectedValues, props?.visible])

  const getList = () => {
    dispatch(getPatientOptionsAsync({ types: '3' }))
      .then(unwrapResult)
      .then((v: any) => {
        setDataList(v?.[0]?.items || [])
      })
  }

  useEffect(() => {
    if (!props?.visible) {
      setSelectedValues([])
      setSelected(undefined)
      form.resetFields()
    }
  }, [props?.visible])

  // ✅ 核心修复：点击添加时，判断长度是否超限
  const handleAddText = (text: string) => {
    const currentText = form.getFieldValue('useMethod') || ''
    const maxLength = 50

    // 将要拼接的结果
    let newText
    if (currentText) {
      newText = currentText + '，' + text
    } else {
      newText = text
    }

    // 超过最大长度 → 不添加，提示
    if (newText.length > maxLength) {
      return
    }

    // 没超过 → 正常添加
    form.setFieldsValue({ useMethod: newText })
    setSelected(text)
  }

  const row = {
    gutter: 10,
    style: {
      color: theme.tc1,
      fontSize: '1rem',
    },
  }

  const col = {
    style: {
      marginBottom: 10,
      lineHeight: '30px',
      height: '30px',
      textAlign: 'center',
      fontSize: '1rem',
    } as React.CSSProperties,
  }

  const firstColumnLayout = {
    labelCol: {
      flex: '0 0 7rem',
    },
  }

  const btn = (selected: boolean) => ({
    style: {
      boxSizing: 'border-box' as const,
      border: selected ? `solid 1px ${theme.c1}` : `solid 1px #d9d9d9`,
      borderRadius: 4,
      color: selected ? theme.c1 : theme.tc1,
      cursor: 'pointer',
      padding: '0px 10px',
    },
  })

  return (
    <>
      <Modal
        title='贴敷用法'
        visible={props?.visible}
        width={720}
        maskClosable={false}
        bodyStyle={{ padding: '16px' }}
        onOk={() => {
          props?.onChange(form.getFieldValue('useMethod'), props?.currentGroupIndex)
        }}
        onCancel={() => {
          props?.onCancel && props?.onCancel()
        }}
      >
        <div style={{ maxHeight: '300px', overflowX: 'hidden', overflowY: 'auto' }}>
          <Row {...row}>
            {dataList?.map((v) => (
              <Col key={v.id} {...col}>
                <div {...btn(v.id === selected)} onClick={() => handleAddText(v.context)}>
                  {v.context}
                </div>
              </Col>
            ))}
          </Row></div>
        <Row style={{ margin: '2px 0 10px 0' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#027AFF',
            }}
            onClick={() => {
              setSettingUseMethodVisible(true)
            }}
          >
            <SettingOutlined
              style={{
                fontSize: '20px',
                color: '#027AFF',
              }}
            />
            <a
              type='text'
              style={{
                marginLeft: '6px',
                fontSize: '16px',
                color: '#027AFF',
              }}
            >
              用法管理
            </a>
          </div>

        </Row>

        <Form form={form}>
          <Row wrap={false} align='middle' {...row}>
            <Form.Item label='' name='useMethod' {...firstColumnLayout} noStyle>
              <Input.TextArea
                ref={inputRef}
                maxLength={50}
                showCount
                rows={3}
                style={{ width: '670px', marginTop: '15px' }}
              />
            </Form.Item>
          </Row>
        </Form>
      </Modal>
      <SettingUseMethodModal
        visible={settingUseMethodVisible}
        onCancel={() => {
          setSettingUseMethodVisible(false)
          getList()
        }}
        onOk={() => {
          setSettingUseMethodVisible(false)
        }}
      />
    </>
  )
}